<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="604px">
    <template #activator="{ on }">
      <v-btn icon v-on="on">
        <app-icon color="mediumTwo">edit</app-icon>
      </v-btn>
    </template>
    <v-card flat class="pb-3 px-2">
      <v-card-title>
        <h6 class="title pt-2 pb-3">Edit User Roles</h6>
      </v-card-title>
      <v-card-text>
        <app-info-field label="First Name">
          {{ userMemberships.user.firstName }}
        </app-info-field>
        <app-info-field label="Last Name">
          {{ userMemberships.user.lastName }}
        </app-info-field>
        <app-info-field label="Email" class="pb-5">
          {{ userMemberships.user.email }}
        </app-info-field>
        <v-row class="flex-column">
          <v-col v-for="role in roleOptions" :key="role.value" class="py-0 striped">
            <v-row class="py-2">
              <v-col>
                {{ role.text }}
                <app-tooltip v-if="getDescriptionForRole(role.value).length > 0" right>
                  <template #activator="{ on }">
                    <sup><v-icon small class="material-icons-round" v-on="on">info</v-icon></sup>
                  </template>
                  <div
                    v-for="(descriptionLine, index) in getDescriptionForRole(role.value)"
                    :key="index"
                  >
                    <span>{{ descriptionLine }}</span>
                    <br />
                  </div>
                </app-tooltip>
              </v-col>
              <v-col cols="1" class="py-0">
                <v-checkbox
                  v-model="form.roles"
                  :value="role.value"
                  color="primary"
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-3 pr-6">
        <v-spacer />
        <app-button-cancel :disabled="saving" @click="cancel()"></app-button-cancel>
        <app-button :request="update">Update</app-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { roleService } from '@/services/role-service'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import { getDescriptionForRole } from '@/helpers/role-helper'
import _ from 'lodash'
import { permissionsMixin } from '@/mixins/permissions'

export default {
  props: {
    userMemberships: { type: Object, required: true }
  },
  data() {
    return {
      form: {
        roles: []
      },
      roles: [],
      dialog: false,
      saving: false
    }
  },
  computed: {
    displayAdminRole() {
      return permissionsMixin.methods.hasAnyPermission([
        'MEMBERSHIP_ADMINISTRATOR_CREATE',
        'MEMBERSHIP_ADMINISTRATOR_DELETE'
      ])
    },
    displayRealTimeFeasibilityRole() {
      return permissionsMixin.methods.hasAnyPermission([
        'DEEP_LENS_COORDINATOR_CREATE',
        'DEEP_LENS_COORDINATOR_DELETE'
      ])
    },
    permittedRoles() {
      let validRoles = _.filter(this.roles, role => role.id !== 'HIDDEN')
      if (!this.displayAdminRole) {
        validRoles = _.reject(validRoles, role => {
          return role.id === 'ADMINISTRATOR'
        })
      }
      if (!this.displayRealTimeFeasibilityRole) {
        validRoles = _.reject(validRoles, role => {
          return role.id === 'DEEP_LENS_COORDINATOR'
        })
      }
      return validRoles
    },
    initialRoles() {
      return _.reject(
        _.map(this.userMemberships.memberships, m => {
          const role = _.find(this.roles, it => it.id === m.userRole)
          if (!_.isNil(role)) {
            return role.id
          } else {
            return null
          }
        }),
        it => _.isNil(it)
      )
    },
    roleOptions() {
      return _.sortBy(
        _.map(this.permittedRoles, role => {
          return { text: _.startCase(role.name), value: role.id }
        }),
        'text'
      )
    }
  },
  watch: {
    initialRoles(newValue) {
      this.form.roles = newValue
    }
  },
  async created() {
    this.roles = _.sortBy((await roleService.list()).data, 'name')
  },
  methods: {
    cancel() {
      this.dialog = false
      this.form.roles = this.initialRoles
    },
    async update() {
      this.saving = true
      await this.$store.dispatch('UPDATE_MEMBERSHIPS', {
        organizationId: MyActiveOrganization.id,
        username: this.userMemberships.user.id,
        roles: this.form.roles
      })
      this.dialog = false
      this.saving = false
    },
    getDescriptionForRole(role) {
      return getDescriptionForRole(role)
    }
  }
}
</script>

<style lang="scss" scoped>
.striped.col:nth-of-type(odd) {
  background-color: var(--v-medium-lighten1);
}
</style>
